export function calculatePlayCount(responseCount){
	let playCount='0'
	if(responseCount){
		playCount=4*Math.round(responseCount/20)
	}
	return playCount
}



